
import React from 'react';
import './BottomTabBar.css';
import { useAppState, TopPage } from '../../context/AppStateContext';
import SilverIcon from '../shared/SilverIcon';

const TABS: { id: TopPage | 'search'; label: string; icon: React.ComponentProps<typeof SilverIcon>['name'] }[] = [
  { id: 'home', label: 'Home', icon: 'home' },
  { id: 'business', label: 'Business', icon: 'business' },
  { id: 'studio', label: 'Studio', icon: 'studio' },
  { id: 'ops', label: 'Ops', icon: 'ops' },
  { id: 'search', label: 'Search', icon: 'search' },
];

interface Props {
  onSearch: () => void;
}

export default function BottomTabBar({ onSearch }: Props) {
  const { appState, setAppState } = useAppState();

  return (
    <nav className="bottom-tab-bar">
      {TABS.map(tab => {
        const isActive = tab.id !== 'search' && appState.currentPage === tab.id;
        return (
          <button
            key={tab.id}
            className={`bottom-tab${isActive ? ' bottom-tab--active' : ''}`}
            onClick={() => {
              if (tab.id === 'search') { onSearch(); return; }
              setAppState(s => ({ ...s, currentPage: tab.id as TopPage }));
            }}
          >
            <SilverIcon name={tab.icon} size={20} />
            <span className="bottom-tab__label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
